// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22.0034 20.4186L22 2.00098L7.00089 2.0021L7.00104 4.0021L20 4.00113V18.4153L22.0034 20.4186Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M18 6.00008H2V22.0001H18V6.00008ZM14.5 15H11V18.5H9V15H5.5V13H9V9.5H11V13H14.5V15Z"}}]};

const QueueFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'queue-filled',
    ref,
    icon: element,
  },
));

QueueFilledIcon.displayName = 'QueueFilledIcon';

export default QueueFilledIcon;
